<template>
  <div class="grid-view" style="height: 100%">
    <search-item
      :key="identify"
      :ref="identify"
      :show-more-scheme="true"
      :show-simple="true"
      :expand-adv="true"
      :search-item-code="searchItemCode"
      :config-module="configModule"
      :auto-init="searchItemAutoInit"
      :custom-search-items="customSearchItems"
      :custom-sim-query-placeholder="simQueryPlaceholder"
      @click-more="value=>isAdvancedQuery=value"
      @advSearchItemCallBack="toAdvancedQuery"
      @simSearchItemCallBack="toSimpleQuery"
      @advToggle="scrollCallback"
    >
      <template slot="operations">
        <slot name="operations" />
      </template>
      <template slot="searchAreaHeader">
        <slot name="searchAreaHeader" />
      </template>
    </search-item>
    <div class="section grid-wrapper">
      <cargo-ag-grid
        :config-module="gridConfigModule"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        :grid-params.sync="gridParams"
        style="width: 100%; height: 100%"
        @gridReady="onGridReady"
      />
    </div>
    <div id="footer-wrapper-tab-billpayment" class="pagination-wrapper">
      <div v-show="showTotalUnverifiedAmount && rowData" :class="'fixedBottom'" style="display: flex;justify-content: flex-end;flex-wrap: wrap">
        <span v-show="selectedDataList.length > 0">
          {{ $t('Clearing.Selected') + selectedDataList.length + ':' }}
        </span>
        <charge-currency-total-group
          v-if="reCalc"
          :key="1"
          :type="totalType"
          :amount-to-currency="localCurrency"
          :data-field="totalDataField"
          :data-provider="selectedDataList.length > 0 ?selectedDataList:rowData"
          :rate-field="rateField"
          :ar-field="arField"
        />
        <span v-if="showTotalUnverifiedAmount && rowData && noWriteOffChargeTotalResult.length > 0" v-text="this.$t('Billing.billingJob_totalAmountNotWrittenOff')" />
        <charge-currency-total-group
          v-if="reCalc"
          :key="2"
          :amount-to-currency="localCurrency"
          mode="group"
          :type="totalType"
          :data-provider="selectedDataList.length > 0 ?selectedDataList:rowData"
          data-field="unverifiedAmount"
          :rate-field="rateField"
          :ar-field="arField"
          @callback="noWriteOffChargeTotalCallback"
        />
      </div>
      <cargo-pagination
        :config-module="gridConfigModule"
        :total="total"
        :page-count="pageCount"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQueryByPage"
      />
    </div>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </div>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { getLoading } from '@/utils/utilBaseElement'
import { DocumentManage } from '@/utils/commonUtil'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import ChargeCountGroup from '@/components/Cargo/Act/chargeSummary/ChargeCountGroup.vue'
import chargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import { getBillingList } from '@/api/clearing/billingNative'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import {
  BILLING_TYPE_AGENT,
  BILLING_TYPE_INTERNAL,
  BILLING_TYPE_NORMAL,
  BILLING_TYPE_OVERSEA
} from '@/class/cargo/model/parameters/BillingConstants'
import {
  CLEARING_STATE_FULL,
  CLEARING_STATE_NON,
  CLEARING_STATE_PARTIAL
} from '@/class/cargo/model/parameters/ClearingConstants'
import checkPermission from '@/utils/permission'
import { User } from '@/class/model/sys/User'
import ColumnUtils from '@/utils/ColumnUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'

export default {
  name: 'BankSlipBillingQuery',
  components: {
    searchItem,
    chargeCurrencyTotalGroup,
    cargoTemplateSelectorDialog,
    ChargeCountGroup
  },
  props: {
    identify: { type: String, required: true, default: 'fmBankSlip' }, // ID
    viewSource: { type: String, required: true, default: 'fmBankSlip' }, // 引用页面
    configModule: { type: String, default: '1300' }, // 高级查询条件
    totalAmountToCurrency: { type: String, default: 'RMB' }, // 折合币种
    totalDataField: { type: String, default: 'amount' }, // 数据字段
    rateField: { type: String, default: 'converRate' }, // 汇率字段
    arField: { type: String, default: 'ap' }, // 收付字段
    isAr: { type: Number, default: -1 }, // 收付
    oversea: { type: Number, default: -1 }, // 国内外
    advance: { type: Number, default: -1 }, // 是否垫付
    hasInvoice: { type: Number, default: -1 }, // 是否开票
    billingClearingStateParam: { type: String, default: '' }, //
    billingJobStateParam: { type: String, default: '' }, //
    billingStateParam: { type: String, default: '' }, //
    showInvoiceState: { type: Boolean, default: true }, // 显示开票状态
    showVerifiedAmount: { type: Boolean, default: true }, // 是否显示已核销金额
    showRealClearingState: { type: Boolean, default: true }, // 显示真实的核销状态
    showUninvoiceAmount: { type: Boolean, default: false }, // 是否显示未开票金额
    showVoucherDate: { type: Boolean, default: false }, // 显示生成凭证日期
    clearingState: { type: Number, default: -1 }, // 核销状态 0:有未销账 1:有已销账 2:全部销完
    showTotalUnverifiedAmount: { type: Boolean, default: false },
    totalType: { type: String, default: 'both', validator: (value) => { return ['revenue', 'ar', 'ap', 'both', 'revenueAbs', 'auto'].includes(value) } }, // 合计类型
    gridConfigModule: { type: String, default: '1300001' } // 列表设置
  },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      selectTypeNames: TYPE_NAMES,
      isAdvancedQuery: true, // 是否为高级查询
      documentManage: new DocumentManage(),
      customSearchItems: [], // 自定义高级查询项
      searchItemAutoInit: true,
      allJobByRole: false, // 查看全部的业务
      simQueryPlaceholder: '快捷检索:账单号',
      searchItemCode: this.$t('Clearing.WaterBillClaims'),
      filterJson: {
        billingNo: '',
        page: 1,
        branchId: 0, // 分公司ID
        conditions: [], // 查询条件
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      filter: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      pageCount: 0,
      selectedData: null,
      selectedDataList: [],
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        // 行点击事件
        onRowClicked: this.onRowClicked,
        // 行勾选事件
        onRowSelected: this.onRowSelected,
        defaultColDef: {
          resizable: true
        }
      },
      form: {
        uuid: ''
      },
      rowData: [],
      searchConditions: {
        applicationStatus: -1,
        chargeStatus: -1,
        mode: 0,
        jobStates: [0, 11, 1, 2, 3],
        chargeStates: [0, 11, 1, 2, 3],
        confirmStates: [0, 1],
        exceptKeys: []
      },
      noWriteOffChargeTotalResult: [], // 未销金额合计结果
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'CargoDocList',
        data: {}
      },
      gridApi: null
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('CargoMsg.Cargo_BillNo'), field: 'billingNo', width: 100, colId: 'billingNo' },
        { headerName: this.$t('CargoMsg.Cargo_AccountStatementNo'), field: 'billingGroupBillingNo', width: 100, colId: 'billingGroupBillingNo' },
        { headerName: this.$t('CargoMsg.Cargo_AgentBillNo'), field: 'counterPartyBillingNo', width: 100, colId: 'counterPartyBillingNo' },
        { headerName: this.$t('CargoMsg.Cargo_BillType'), field: 'billingType', width: 100, colId: 'billingType' },
        { headerName: this.$t('CargoMsg.Cargo_RevenueAndExpenditureType'), field: 'ar', width: 100, colId: 'ar',
          valueFormatter: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_InvoiceTitle'), field: 'title', width: 100, colId: 'title' },
        { headerName: this.$t('CargoMsg.Cargo_InvoicingRequirements'), field: 'invoiceDemand', width: 100, colId: 'invoiceDemand' },
        { headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo'), field: 'accountId', width: 100, colId: 'accountId',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: 'ETD', field: 'jobEtd', width: 100, colId: 'jobEtd',
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: 'ETA', field: 'jobEta', width: 100, colId: 'jobEta',
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ProofDate'), field: 'voucherExportDate', width: 100, colId: 'voucherExportDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'), field: 'jobNo', width: 200,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'router-and-print',
            attrs: {
              useRoute: true,
              usePrint: true,
              routeName: 'FinanceManage',
              routeParamKeys: { jobNo: 'jobNo' },
              routeTitle: this.$t('Clearing.FinancialAudit'),
              routePermissions: ['module_ACVerify'],
              extraRouteParams: {},
              printMethod: this.showBusinessInfo
            }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_MblNo'), field: 'jobMbl', width: 100, colId: 'mbl' },
        { headerName: this.$t('CargoMsg.Cargo_VesselAndVoyage'), field: 'voyageFlight', width: 100, colId: 'voyageFlight' },
        { headerName: this.$t('CargoMsg.Cargo_PortOfLoading'), field: 'pol', width: 100, colId: 'pol',
          cellRenderer: (params) => {
            return ColumnUtils.portLabelFunc(params.data, params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DestinationPort'), field: 'pod2', width: 100, colId: 'pod2',
          cellRenderer: (params) => {
            return ColumnUtils.portLabelFunc(params.data, params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Creator'), field: 'inputBy', width: 100, colId: 'inputBy',
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_CustomerService'), field: 'jobCsr', width: 100, colId: 'job_csr',
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BillStatus'), field: 'state', width: 100, colId: 'state',
          cellRenderer: (params) => {
            return ColumnUtils.billingStateLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InvoicingStatus'),
          field: 'invoiceState',
          width: 100,
          colId: 'invoiceState',
          cellRenderer: (params) => {
            return ColumnUtils.invoiceStateLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WriteOffStatus'),
          field: 'realClearingState',
          width: 100,
          colId: 'realClearingState',
          cellRenderer: (params) => {
            return ColumnUtils.clearingStateLabFun(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Currency'), field: 'currency', width: 100, colId: 'currency' },
        { headerName: this.$t('CargoMsg.Cargo_Amount'), field: 'amount', width: 100, colId: 'amount',
          cellRenderer: params => {
            return ColumnUtils.formatNumber(params.value, 2, true)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Aging'), field: 'aging', width: 100, colId: 'aging' },
        { headerName: this.$t('CargoMsg.Cargo_PaymentCompany'), field: 'paymentCompany', width: 100, colId: 'paymentCompany' },
        { headerName: this.$t('CargoMsg.Cargo_ClaimDate'), field: 'clearingDate', width: 100, colId: 'clearingDate',
          valueFormatter: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffAmount'), field: 'verifiedAmount', width: 100, colId: 'verifiedAmount',
          valueFormatter: (params) => {
            return ColumnUtils.formatNumber(params.value, 2, true)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_NotInvoicedMoney'), field: 'uninvoiceAmount', width: 100, colId: 'uninvoiceAmount',
          valueFormatter: (params) => {
            return ColumnUtils.formatNumber(params.value, 2, true)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_TotalCurrency'), field: 'currencyAmount', width: 100, colId: 'currencyAmount' },
        { headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'remark', width: 100, colId: 'remark' },
        { headerName: this.$t('CargoMsg.Cargo_BookingNo'), field: 'bookingNo', width: 100, colId: 'bookingNo' }
      ]
    }
  },
  async created() {
    await this.preloadBasicData()
    await cache.load(cacheName.OFFICE, cacheName.CONFIG)
    this.office = cache.office
    this.allJobByRole = checkPermission(['role_query_allBillings'])
    this.setLocalCurrency()
  },
  beforeMount() {

  },
  beforeDestroy() {

  },
  methods: {
    // 初始化配置参数
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
    },
    onGridReady(p) {
      this.gridApi = p.api
    },
    refreshPageHandler() {
      this.doAdvancedQuery()
    },
    // 分页查询
    toQueryByPage() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    scrollCallback() {},
    toSimpleQuery(keyword) {
      this.filter.pageNum = 1
      this.filterJson.billingNo = keyword.trim()
      this.filterJson.conditions = []
      this.doAdvancedQuery()
    },
    toAdvancedQuery(data) {
      // 高级查询条件组装
      if (typeof data !== 'undefined') {
        this.filter.pageNum = 1
        this.filterJson.billingNo = ''
      }
      this.doAdvancedQuery(data)
    },
    // 高级查询
    async doAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        this.filterJson.conditions = data
      }
      if (this.isAr !== -1) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'billing.AR', this.isAr === 1, AdvancedSearchConsts.OPERATOR_EQUAL.code))
      }
      if (this.advance !== -1) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'charge.ADVANCE', this.advance === 1, AdvancedSearchConsts.OPERATOR_EQUAL.code))
      }
      if (this.hasInvoice !== -1 && !AdvancedSearchOption.hasField('charge.INVOICE_UUID', this.filterJson.conditions) && !AdvancedSearchOption.hasField('invoice.INVOICEDATE', this.filterJson.conditions)) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'charge.INVOICE_UUID', null, this.hasInvoice === 0 ? AdvancedSearchConsts.OPERATOR_IS_NULL.code : AdvancedSearchConsts.OPERATOR_IS_NOT_NULL.code))
      }
      if (this.oversea === 0) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'billing.BILLINGTYPE', BILLING_TYPE_INTERNAL.code, AdvancedSearchConsts.OPERATOR_EQUAL.code))
      } else if (this.oversea === 1) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'billing.BILLINGTYPE', [BILLING_TYPE_OVERSEA.code, BILLING_TYPE_NORMAL.code, BILLING_TYPE_AGENT.code], AdvancedSearchConsts.OPERATOR_IN.code))
      }
      if (!AdvancedSearchOption.hasField('billing.STATE', this.filterJson.conditions)) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'billing.STATE', [3], AdvancedSearchConsts.OPERATOR_NOT_IN.code))
      }
      if (this.clearingState !== -1) {
        if (this.clearingState === CLEARING_STATE_NON.code || this.clearingState === CLEARING_STATE_PARTIAL.code) {
          this.filterJson.conditions.push(new AdvancedSearchOption(null, 'charge.PAID_OFF', false, AdvancedSearchConsts.OPERATOR_EQUAL.code))
        } else if (this.clearingState === CLEARING_STATE_FULL.code) {
          this.filterJson.conditions.push(new AdvancedSearchOption(null, 'billing.CLEARING_STATE', CLEARING_STATE_FULL.code, AdvancedSearchConsts.OPERATOR_EQUAL.code))
        }
      }
      if (this.exceptKeys && this.exceptKeys.length > 0) {
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'charge.UUID', this.exceptKeys, AdvancedSearchConsts.OPERATOR_NOT_IN.code))
      }
      this.filterJson.requires = []
      if (this.showVerifiedAmount || this.showRealClearingState) {
        this.filterJson.requires.push('writeoff')
      }
      if (this.showInvoiceState || this.showUninvoiceAmount) {
        this.filterJson.requires.push('invoice')
      }
      if (this.showVoucherDate) {
        this.filterJson.requires.push('voucherDate')
      }

      const isAging = AdvancedSearchOption.getOption('billing.ETD', this.filterJson.conditions)
      if (isAging) {
        isAging.value = new Date()
      }

      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.hasCheckRole = true
      this.filterJson.requestSource = 'BankSlipCharge'
      this.loading = getLoading()
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize

      if (this.allJobByRole || AdvancedSearchOption.hasField('job.SALES_ID', this.filterJson.conditions)) {
        this.doQueryHandler(this.filterJson)
      } else {
        this.doQueryHandler(this.filterJson)
      }
    },
    doQueryHandler(filterJson) {
      getBillingList(filterJson).then(res => {
        this.handleQueryData(res)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      this.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.total = Number(res.data.total)
      this.pageCount = res.data.pages
      this.selectedDataList = []
      this.selectedData = null
      this.gridApi.clearFocusedCell()
      this.loading.close()
    },
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedData = null
      const node = event.data
      if (node.uuid) {
        this.selectedData = node
      }
    },
    onRowSelected(event) {
      if (!event || !event.data) return
      if (event.node.isSelected()) {
        this.selectedDataList.push(event.data)
      } else {
        this.selectedDataList = this.gridApi.getSelectedRows()
      }
      this.onRowClicked(event)
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.selectedData = {}
      if (this.gridApi) {
        this.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            const f = node.data
            if (f.uuid) {
              this.selectedData = f
            }
          }
        })
      }
    },
    showBusinessInfo(e) {
      if (!this.selectedData) return
      this.templateSelectorDialog.ctx = this.selectedData
      this.templateSelectorDialog.category = 'JOB_DETAIL'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedData.jobUuid }
      this.templateSelectorDialog.visible = true
    },
    noWriteOffChargeTotalCallback(data) {
      this.noWriteOffChargeTotalResult = data
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    }
  }
}
</script>

<style lang="scss">
#app #verify-tree-grid {
  .ag-theme-balham {
    .ag-row-hover {
      background: #9bddff !important;
    }
    .ag-row-focus {
      background: #6abdff !important;
    }
  }
  .main-inner-row {
    display: flex;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .query-input-spacing {
    padding-right: 10px;
  }
}
</style>
